import InviteFriendPopup from './InviteFriendPopup'

export default InviteFriendPopup
// eslint-disable-next-line import/export
export * from './InviteFriendPopup'
